import { useQuery } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  TicketsWithPagination,
  TicketsWithPaginationParams,
} from "./apiEcms.types";

const getTechnicalRequests = async (
  { page, size, filters }: TicketsWithPaginationParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<TicketsWithPagination>(
    "/technical-requests",
    {
      params: {
        page,
        size,
        status: filters,
      },
      signal,
    },
  );

  return data;
};

export const useGetTechnicalRequests = ({
  page,
  size,
  filters,
}: TicketsWithPaginationParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.TECHNICAL_REQUESTS, page, size, [...filters].sort()],
    queryFn: ({ signal }) =>
      getTechnicalRequests({ page, size, filters }, signal),
    staleTime: Infinity,
  });
